//@ts-nocheck

import { FC, lazy } from "react";
import { routes as bookingRoutes } from "./components/AdminMerchant/Booking/routes";
import { routes as retailRoutes } from "./components/AdminMerchant/Retail/Information/routes";
const Platform = lazy(() => import("./pages/platform/Platform"));
const AuthPage = lazy(() => import("./pages/auth/index"));
const Preview = lazy(() => import("./pages/preview/Preview"));
const PreviewV2 = lazy(() => import("./pages/preview_v2/Preview"));
const SSO = lazy(() => import("./pages/fnb/SSO"));
const ActiveFailure = lazy(() => import("./pages/retail/ActiveFailure"));
const DialogShareQrCode = lazy(
  () => import("./pages/retail/DialogShareQrCode")
);
const Share = lazy(() => import("./pages/retail/Share"));
const PageNotFound = lazy(() => import("./components/Page/PageNotFound"));
const SessionExpired = lazy(() => import("./pages/SessionExpired"));
const InternalServerError = lazy(() => import("./pages/InternalServerError"));
const FnbThemeSetting = lazy(() => import("./pages/FnbThemeSetting"));
const ThemeSetting = lazy(() => import("./pages/retail/ThemeSetting"));
const PreviewShop = lazy(() => import("./pages/preview/PreviewShop"));
const PreviewMobile = lazy(() => import("./pages/preview/m/Preview"));
const PreviewWebsite = lazy(() => import("./pages/preview/PreviewWebsite"));
const AdminMerchant = lazy(() => import("./pages/retail/AdminMerchant"));
const MykiotDomain = lazy(() => import("./pages/retail/MykiotDomain"));
const WelcomePage = lazy(() => import("./pages/fnb/onboarding/WelcomePage"));
const DesignPhoto = lazy(
  () => import("./components/AdminMerchant/Retail/StockPhoto/DesignPhoto")
);
const RetailSSO = lazy(() => import("./pages/retail_widget/SSO"));
const RetailOnboarding = lazy(
  () => import("./pages/retail_widget/onboarding/WelcomePage")
);
const GuideRedirect = lazy(
  () => import("./pages/retail_widget/guide_redirect_link")
);
const PreviewLandingPage = lazy(
  () => import("./pages/preview_landingpage/Preview")
);

// interface
export interface Route {
  key: string;
  title: string;
  path: string;
  enabled: boolean;
  component: FC<{}>;
}

const allRoutes: any[] = [...bookingRoutes, ...retailRoutes];

export const routes: Array<Route> = [
  {
    key: "home-route",
    title: "Home",
    path: "/:platform",
    enabled: true,
    component: Platform,
  },
  {
    key: "home-route",
    title: "Home",
    path: "/preview/:id",
    enabled: true,
    component: Preview,
  },
  {
    key: "preview-v2-route",
    title: "Trang trí cửa hàng",
    path: "/preview-v2/:id",
    enabled: true,
    component: PreviewV2,
  },
  {
    key: "preview-landing_page",
    title: "Xem thử website",
    path: "/preview-landing-page",
    enabled: true,
    component: PreviewLandingPage,
  },
  {
    key: "design-photo-route",
    title: "Thiết kế hình ảnh",
    path: "/design-photo/",
    enabled: true,
    component: DesignPhoto,
  },
  {
    key: "home-route",
    title: "Home",
    path: "/preview-fnb/:id",
    enabled: true,
    component: Preview,
  },
  {
    key: "home-route",
    title: "Retail Guide Redirect Link",
    path: "/retail/guide-redirect-link",
    enabled: true,
    component: GuideRedirect,
  },
  {
    key: "home-route",
    title: "Home",
    path: "/retail/active-failure",
    enabled: true,
    component: ActiveFailure,
  },
  {
    key: "home-route",
    title: "Home",
    path: "/retail/dialog-share-qrcode",
    enabled: true,
    component: DialogShareQrCode,
  },
  {
    key: "home-route",
    title: "Home",
    path: "/retail/share",
    enabled: true,
    component: Share,
  },
  {
    key: "home-route",
    title: "Theme Setting",
    path: "/:platform/theme-setting",
    enabled: true,
    component: ThemeSetting,
  },
  {
    key: "home-route",
    title: "Home",
    path: "/404",
    enabled: true,
    component: PageNotFound,
  },
  {
    key: "home-route",
    title: "Home",
    path: "/session-expired",
    enabled: true,
    component: SessionExpired,
  },
  {
    key: "home-route",
    title: "Home",
    path: "/internal-server-error",
    enabled: true,
    component: InternalServerError,
  },
  {
    key: "home-route",
    title: "Home",
    path: "/",
    enabled: true,
    component: FnbThemeSetting,
  },
  {
    key: "home-route",
    title: "Home",
    path: "/:platform/preview",
    enabled: true,
    component: PreviewShop,
  },
  {
    key: "home-route",
    title: "Preview Mobile",
    path: "/retail/m/preview",
    enabled: true,
    component: PreviewMobile,
  },
  {
    key: "home-route",
    title: "Home",
    path: "/preview-website",
    enabled: true,
    component: PreviewWebsite,
  },
  {
    key: "home-route",
    title: "Home",
    path: "/mykiot-domain",
    enabled: true,
    component: MykiotDomain,
  },
  {
    key: "home-route",
    title: "admin-merchant",
    path: "/:platform/admin-merchant/*",
    enabled: true,
    component: AdminMerchant,
  },
  {
    key: "home-route",
    path: "/:platform/sso",
    enabled: true,
    component: AuthPage,
  },
  ...allRoutes,
];
